// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3gqqx","content":"Layout_content__1NIkv","addWorkspaceMobile":"Layout_addWorkspaceMobile__2KOio"};